import React, { useEffect, useState } from "react";

import "./Comments.styles.scss";
import { ReactComponent as CrossIcon } from "../../assets/icons/cross.svg";
import { useCommentsScrollSelector } from "../../store";
import { useNavigationHooks } from "../../hooks/shared-hooks/use-navigation-hooks";
import { useCommentsUrlHooks } from "../../hooks/comments-hooks/use-comments-url-hooks";
import { Section } from "./Section/Section";
import { General } from "./General/General";
// import { Specific } from "./Specific/Specific";

export const Comments: React.FC = () => {
  const { commentBelongTo } = useCommentsUrlHooks();
  const [isGeneralComments, setIsGeneralComments] = useState(true);
  const { removeParams } = useNavigationHooks();
  const commentsScroll: boolean = useCommentsScrollSelector();

  useEffect(() => {
    if (commentsScroll) {
      setIsGeneralComments(!commentBelongTo);
    }
  }, [commentBelongTo, commentsScroll]);

  return (
    <div className="comments flex-col-fs-st">
      <div className="comments__header flex-row-fe-fc">
        {/* <span className="comments__title">COMMENTS</span> */}
        <CrossIcon
          className="chat-rooms__cross-icon scale-click"
          fill="#898989"
          onClick={() => removeParams(["bar", "question-uuid", "reply"])}
        />
      </div>
      <div className="comments__body flex-col-fs-st">
        <Section
          title="GENERAL COMMENTS"
          onClick={() => setIsGeneralComments(true)}
          isOpen={isGeneralComments}
          hasInputTrigger>
          {(findTargetRef) => <General findTargetRef={findTargetRef} />}
        </Section>
        {/* <Section
          title="SPECIFIC COMMENT"
          onClick={() => setIsGeneralComments(false)}
          isOpen={!isGeneralComments}>
          {(findTargetRef) => <Specific findTargetRef={findTargetRef} />}
        </Section> */}
      </div>
    </div>
  );
};
